import api from "../../../services/api"
import { IOccurrenceWithLogs } from "../../../types/occurrence";

export const occurrenceDetailsQueryKey = (occurrenceId?: number) => ['occurrence_details', { occurrenceId }];

export const getOccurrenceDetailsByOccurrenceId = async (occurrenceId: number, signal: AbortSignal) =>
    (await api.get<IOccurrenceWithLogs>(`/schedulling/occurrence/${occurrenceId}`, { signal })).data;